import { useEffect, useState } from "react";
import "./style.scss";
import SplashScreen from "../splashscreen/index";
import ErrorBoundary from "../errorboundary";
import GameStart from "../gamestart";
import { connect } from "react-redux";
import { intialize } from "../../store/intialize/operations";
import CuLayout from "../../utils/gameLayout";
import { Alert } from "@material-ui/lab";

function App({ isLoaded, intialize }) {
	const [failedIntilize, setFailedIntilize] = useState(false);

	const [msg, setMessage] = useState(
		`Couldn't load the request. Please check your internet connection and retry`
	);

	useEffect(() => {
		intialize(
			() => setFailedIntilize(false),
			() => {
				setMessage(
					`Couldn't load the request. Please check your internet connection and retry`
				);
				setFailedIntilize(true);
			},
			''
		);
		// eslint-disable-next-line
	}, []);

	if (failedIntilize) {
		return (
			<ErrorBoundary>
				<div className="app_alert">
					<Alert severity="error">
						<h3>{msg}</h3>
					</Alert>
				</div>
			</ErrorBoundary>
		);
	} else {
		return (
			<>
				<ErrorBoundary>
					{!isLoaded ? (
						<SplashScreen />
					) : (
						<CuLayout>
							<GameStart />
						</CuLayout>
					)}
				</ErrorBoundary>
			</>
		);
	}
}

const mapStateToProps = (state) => {
	return {
		isLoaded: state.intialize.isLoaded,
	};
};

const mapDisPatchToProps = (dispatch) => {
	return {
		intialize: (success, failure, token) =>
			dispatch(intialize(success, failure, token)),
	};
};

export default connect(mapStateToProps, mapDisPatchToProps)(App);
